module.exports = __webpack_public_path__ + "75df787185653aeca7247ba54c239991.svg";